import angular from "angular";

angular
    .module('inviteHistory', [])
    .component('inviteHistory', {
        controller: [controller],
        template: require('./invite-history.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller() {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.invite = $ctrl.resolve.invite;
    };

}

export default "inviteHistory";


// WEBPACK FOOTER //
// ./resources/assets/modules/invites-control/invite-history/invite-history.js